import { everest } from '~/services/serviceInstances';

export const duplicateWorkflow = async ({
  id,
  targetWorkflowId,
}: {
  id: string;
  targetWorkflowId?: string;
}) => {
  const url = targetWorkflowId
    ? `/workflows/${id}/duplicate?targetWorkflowId=${targetWorkflowId}`
    : `/workflows/${id}/duplicate`;
  return await everest.post(url);
};
